import { useTranslation } from "react-i18next";
import { Ruler } from "lucide-react";
import clsx from "clsx";
import { Button } from "components/common/Button";
import type { PageScaleControlProps } from "./types";

/**
 * "Change scale" button for the Cable Groups action row. Shown only on an
 * already-calibrated, editable page; opens the change-scale dialog and toggles
 * to a cancel action while picking points.
 */
export const PageScaleControl = ({
  isCalibrated,
  canEdit,
  isPageRecalibrating,
  isChangePageScaleDisabled,
  onChangePageScale,
  onCancelPageRecalibration,
}: PageScaleControlProps) => {
  const { t } = useTranslation();

  if (!isCalibrated || !canEdit) return null;

  return (
    <Button
      size="sm"
      variant={isPageRecalibrating ? "primary" : "outline"}
      className={clsx({ "!text-blue-600": !isPageRecalibrating })}
      onClick={
        isPageRecalibrating ? onCancelPageRecalibration : onChangePageScale
      }
      disabled={!isPageRecalibrating && isChangePageScaleDisabled}
      startAdornment={<Ruler className="w-3.5 h-3.5" />}
    >
      {isPageRecalibrating
        ? t("smartSurveyor.pageCalibration.pickingPoints")
        : t("smartSurveyor.pageCalibration.changeScale")}
    </Button>
  );
};
